<template>
  <div>
    <multi-selection-list
      caption="Properties"
      :items="properties"
      @add="addProperty"
      @remove="removeProperty"
    />
    <div style="margin-top: 10px" class="flex justify-end">
      <input
        class="btn"
        type="button"
        style="margin-right: 5px"
        value="All"
        @click="selectAll"
      />
      <input class="btn" type="button" value="Clear" @click="clear" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    propertyType: {
      required: true,
      value: String,
      validator: function (value) {
        return ["agent", "campaign", "queue"].indexOf(value) !== -1;
      },
    },

    argType: {
      required: true,
      value: String,
    },

    items: {
      required: true,
      value: Array,
    },
  },

  computed: {
    properties() {
      return this.propertiesList.map((x) => ({
        name: x.key,
        selected: this.items.includes(x.key),
      }));
    },

    propertiesList() {
      if (this.propertyType === "campaign")
        return this.$diamond.campaignPropertiesAndTypes;
      else if (this.propertyType === "agent")
        return this.$diamond.agentPropertiesAndTypes;
      else if (this.propertyType === "queue")
        return this.$diamond.queuePropertiesAndTypes;
      throw "Invalid property type provided";
    },
  },

  methods: {
    addProperty(name) {
      this.items.push(name);
      this.$store.getters[this.argType].addProperty(name);
      this.$emit("selected", name)
    },

    removeProperty(name) {
      var index = this.items.indexOf(name);
      this.items.splice(index, 1);
      this.$store.getters[this.argType].removeProperty(name);
      this.$emit("removed", name)
    },

    clear() {
      let i = this.items.length;
      while(i--) {
        this.$store.getters[this.argType].removeProperty(this.items[i]);
        var name = this.items[i]
        this.items.splice(i, 1);
        this.$emit("removed", name);
      }
    },

    selectAll() {
      var propertyList = this.properties
        .map((x) => x.name)
        .filter((x) => !this.items.includes(x));
      for (let i = 0; i < propertyList.length; i++)
        this.addProperty(propertyList[i]);
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.justify-end {
  justify-content: flex-end;
}

.btn {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #0186c9;
  border: 0;
  padding: 6px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
</style>